module.exports = __webpack_public_path__ + "img/Customized.5eab6d07.svg";